export const USER_EXPORT_COLUMN_HEADERS = [
  'Employee ID',
  'Username',
  'Full Name',
  'Email',
  'Contact Number',
  'Role',
  'Department',
  'Location',
  'Status',
  'Email Verified',
  'Password Setup Pending',
  'Created At',
  'Updated At',
  'Last Login',
];

const USER_EXPORT_DEFAULT_HEADERS = new Set([
  'Employee ID',
  'Username',
  'Full Name',
  'Email',
  'Role',
  'Department',
  'Location',
  'Status',
]);

export const createUserExportColumnsState = () => (
  USER_EXPORT_COLUMN_HEADERS.reduce((acc, header) => {
    acc[header] = USER_EXPORT_DEFAULT_HEADERS.has(header);
    return acc;
  }, {})
);

export const getSelectedExportColumnHeaders = (exportColumns) => (
  Object.entries(exportColumns)
    .filter(([, enabled]) => enabled !== false)
    .map(([header]) => header)
);
